import React from "react";
import type { FormField } from "../types";
import { ATTRIBUTE_TYPE_LIST } from "../types";

interface Props {
  fields: FormField[];
  formData: Record<string, string>;
  onFieldChange: (fieldName: string, value: string) => void;
  errors: Record<string, string>;
  // Field definition ids are per customer, not per meeting, so an events list showing two
  // meetings from the same series would otherwise emit duplicate input ids and labels
  // pointing at the wrong meeting's field.
  idPrefix: string;
}

const PersonalInfoSection: React.FC<Props> = ({
  fields,
  formData,
  onFieldChange,
  errors,
  idPrefix
}) => {
  if (!fields || fields.length === 0) return null;

  return (
    <div className="pc-card">
      <div className="pc-card-header">
        <h2 className="pc-card-title">Personal Information</h2>
        <p className="pc-card-subtitle">Fields marked with * are required</p>
      </div>
      <div className="pc-card-body">
        <div className="pc-field-grid">
          {fields.map((field) => {
            const isListType =
              field.attributeType === ATTRIBUTE_TYPE_LIST &&
              !!field.attributeOptions &&
              field.attributeOptions.length > 0;

            return (
              <div key={field.id} className="pc-field">
                <label className="pc-label" htmlFor={`${idPrefix}field-${field.id}`}>
                  {field.name}
                  {field.required && <span className="pc-required">*</span>}
                </label>
                {isListType ? (
                  <select
                    id={`${idPrefix}field-${field.id}`}
                    className={`pc-input ${
                      errors[field.name] ? "pc-input-error" : ""
                    }`}
                    value={formData[field.name] || ""}
                    onChange={(e) => onFieldChange(field.name, e.target.value)}
                  >
                    <option value="">{`Select ${field.name.toLowerCase()}`}</option>
                    {field.attributeOptions!.map((opt) => (
                      <option key={opt.id} value={String(opt.id)}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={`${idPrefix}field-${field.id}`}
                    type={
                      field.name.toLowerCase().includes("email")
                        ? "email"
                        : field.name.toLowerCase().includes("phone")
                        ? "tel"
                        : "text"
                    }
                    className={`pc-input ${
                      errors[field.name] ? "pc-input-error" : ""
                    }`}
                    placeholder={`Enter ${field.name.toLowerCase()}`}
                    value={formData[field.name] || ""}
                    onChange={(e) => onFieldChange(field.name, e.target.value)}
                  />
                )}
                {errors[field.name] && (
                  <span className="pc-error-text">{errors[field.name]}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
